import { FunctionComponent } from 'react';

import { isOdd } from 'utils/math';

import LayoutContainer from 'components/layout/LayoutContainer';
import { Directions } from 'components/modules/public/layout/sections/blocks/TwoCol/types';
import DescriptionTwoCol from 'components/modules/public/layout/sections/DescriptionTwoCol';

import StyledComponent from './styles';
import { Element, Props } from './types';

const PublicSectionTwoColsVariantDefault: FunctionComponent<Props> = ({
    translations,
    videoType,
}) => {
    const { headline, subheadline, list } = translations;

    return (
        <StyledComponent className="public-section-two-cols-variant-default">
            <LayoutContainer>
                {headline && (
                    <div
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: headline }}
                    />
                )}
                {subheadline && (
                    <div
                        className="subheadline"
                        dangerouslySetInnerHTML={{ __html: subheadline }}
                    />
                )}

                <DescriptionTwoCol
                    list={list.map((listElem: Element, index: number) => ({
                        key: listElem?.leftColDescription || listElem?.rightColDescription,
                        direction: isOdd(index) ? Directions.Default : Directions.Reverse,
                        leftCol: {
                            image: listElem?.leftColImage
                                ? {
                                    imgProps: {
                                        src: listElem?.leftColImage,
                                    },
                                }
                                : null,
                            copy: listElem?.leftColHeadline ||
                                listElem?.leftColSubheadline ||
                                listElem?.leftColDescription
                                ? {
                                    headline: listElem?.leftColHeadline,
                                    subheadline: listElem?.leftColSubheadline,
                                    description: listElem?.leftColDescription,
                                }
                                : null,
                            video: listElem?.leftColVideo
                                ? {
                                    videoProps: {
                                        src: listElem?.leftColVideo,
                                        type: videoType,
                                    },
                                }
                                : null,
                        },
                        rightCol: {
                            image: listElem?.rightColImage
                                ? {
                                    imgProps: {
                                        src: listElem?.rightColImage,
                                    },
                                }
                                : null,
                            copy: listElem?.rightColHeadline ||
                                listElem?.rightColSubheadline ||
                                listElem?.rightColDescription
                                ? {
                                    headline: listElem?.rightColHeadline,
                                    subheadline: listElem?.rightColSubheadline,
                                    description: listElem?.rightColDescription,
                                }
                                : null,
                            video: listElem?.rightColVideo
                                ? {
                                    videoProps: {
                                        src: listElem?.rightColVideo || null,
                                        type: videoType,
                                    },
                                }
                                : null,
                        },
                    }))}
                />
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicSectionTwoColsVariantDefault;
